import axios from "axios";
import { logoutUser, refreshTokenSuccess } from "../store/slice/authSlice";
import { logout, fetchCurrentUser } from "../features/auth/authService";
import {store} from "../store/store"

// Create a base axios instance
const axiosInstance =  axios.create({
    baseURL: process.env.REACT_APP_API_KEY,
    withCredentials: true, // <== IMPORTANT: sends httpOnly cookies like access_token, refresh_token
    headers: {
      "Content-Type": "application/json",
    },
});
  
let isRefreshing = false;
let failedQueue = [];

const processQueue = (error, token = null) => {
failedQueue.forEach((prom) => {
    if (error) {
    prom.reject(error);
    } else {
    prom.resolve(token);
    }
});

failedQueue = [];
};
  
// Response interceptor
axiosInstance.interceptors.response.use(
    (response) => response,
    async (error) => {
        const originalRequest = error.config;
    
        // If 401 and not retrying yet
        if (
                error.response?.status === 401 &&
                !originalRequest._retry &&
                !originalRequest.url.includes("api/auth/signin") &&
                !originalRequest.url.includes("api/auth/refresh-token")
        ) {
            originalRequest._retry = true;
            if (isRefreshing) {
                // console.log("refreshing token")
                return new Promise(function (resolve, reject) {
                    failedQueue.push({ resolve, reject });
                })
                .then(() => axiosInstance(originalRequest))
                .catch((err) => Promise.reject(err));
            }
    
            isRefreshing = true;
    
            try {
                await axiosInstance.post("/api/auth/refresh-token"); // uses refresh_token from httpOnly cookie
                // Update Redux state with new user data
                const data = await fetchCurrentUser();
                // console.log("refreshRes>>>", res)
                store.dispatch(refreshTokenSuccess(data?.user));
                processQueue(null);
                return axiosInstance(originalRequest); // retry original request
            } catch (err) {
                processQueue(err, null);
                // Optionally redirect to login
                store.dispatch(logoutUser());
                logout();
                console.warn("Token refresh failed.");
                return Promise.reject(err);
            } finally {
                isRefreshing = false;
            }
        }
    
        return Promise.reject(error);
    }
);

export default axiosInstance;